import React, { createContext, useContext, useState, useEffect } from "react";

const AuthContext = createContext(null);

async function getUserCookie() {
  const cookie = await window.cookieStore.get("cor.timesheets.user")
  return JSON.parse(decodeURIComponent(cookie?.value ?? "j:{}").slice(2))
}

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const onStorage = (e) => {
      if (!e) return;
      if (
        e.key === "loggedInUser" ||
        e.key === "jwt_token" ||
        e.key === "__logout__"
      ) {
        getUserCookie().then((lu) => {
          setUser(lu);
        })
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  const getUser = async () => {
    if (user) {
      return user
    } else {
      const new_user = await getUserCookie()
      setUser(new_user)
      return new_user
    }
  }

  const logout = () => {
    try {
      localStorage.removeItem("jwt_token");
      localStorage.removeItem("loggedInUser");
      localStorage.removeItem("lastActive");
      localStorage.setItem("__logout__", Date.now());
      localStorage.removeItem("__logout__");
    } catch (e) {}
    setUser(null);
    try {
      window.location.href = "/login";
    } catch (e) {}
  };

  const updateCookie = (newval) => {
    window.cookieStore.set("cor.timesheets.user", encodeURIComponent("j:" + JSON.stringify(newval)))
  }

  return (
    <AuthContext.Provider value={{ user, setUser, getUser, logout, updateCookie }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);

export default AuthContext;
